import { render, staticRenderFns } from "./BenefitsPage.vue?vue&type=template&id=1254d594"
import script from "./BenefitsPage.vue?vue&type=script&lang=js"
export * from "./BenefitsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports